import {
    Badge,
    Banner,
    Button,
    ButtonGroup,
    Card,
    Checkbox,
    DataTable,
    Heading,
    Icon,
    OptionList,
    Page,
    Scrollable,
    Sheet,
    Spinner,
    Stack,
    TextField,
    TextStyle,
    Thumbnail,
} from "@shopify/polaris"
import { CancelSmallMinor, DeleteMinor, EditMinor, SearchMinor } from "@shopify/polaris-icons"
import React, { Component } from "react"
import InfinitScroll from "react-infinite-scroll-component"
export default class MultipleProduct extends Component {
    state = {
        listCheckbox: [],
        checkAll: false,
        sheetActive: false,
        selected: [],
        all_product: [],
        loading: true,
        loadingEndPoint: false,
        nextCursor: "",
        textSearch: "",
        listPreOrder: [],
        loaded: true,
        searchSingleProduct: "",
    }

    constructor(props: Props) {
        super(props)
        this.scrollBottom = React.createRef()
    }

    handleCreateProfile = () => {
        this.props.redirectToPage("MultipleProductDetail", null)
    }

    render() {
        const {
            checkAll,
            listCheckbox,
            sheetActive,
            loading,
            selected,
            all_product,
            textSearch,
            loaded,
            searchSingleProduct,
        } = this.state

        // let { listPreOrder } = this.state
        let rows = [
            [
                <Checkbox
                // onChange={() => this.handleChangeProductsSelected(listPreOrder[i].id)}
                // checked={this.checkItemExistsInArray(listCheckbox, listPreOrder[i].id)}
                />,
                <div>
                    <h3>New Profile</h3>
                </div>,
                "true",
                "5 product selected",
                <ButtonGroup segmented>
                    <Button
                        icon={<Icon source={EditMinor} />}
                        // onClick={() =>
                        //     this.props.redirectToPage("SingleProductDetail", listPreOrder[i].id)
                        // }
                        size="slim"
                    ></Button>
                    <Button
                        destructive
                        icon={<Icon source={DeleteMinor} />}
                        size="slim"
                        // onClick={() => this.handleDeletePreOrder(i)}
                    ></Button>
                </ButtonGroup>,
            ],
        ]
        let heading = [
            <Checkbox onChange={() => this.handleCheckAll()} checked={checkAll} />,
            "Profile",
            "Status",
            "Condition",
            "Action",
        ]
        // console.log("listCheckbox", listCheckbox)
        // console.log("listPreOrder", listPreOrder)
        // listPreOrder = listPreOrder.filter(this.searched(searchSingleProduct))
        // for (let i = 0; i < listPreOrder.length; i++) {
        //     let array = []
        //     array.push(
        //         <Checkbox
        //             onChange={() => this.handleChangeProductsSelected(listPreOrder[i].id)}
        //             checked={this.checkItemExistsInArray(listCheckbox, listPreOrder[i].id)}
        //         />,
        //     )
        //     array.push(
        //         <div className="productInfo">
        //             <Thumbnail
        //                 source={listPreOrder[i].image.src}
        //                 size="small"
        //                 alt="Black choker necklace"
        //             />
        //             <h3
        //                 className="productName"
        //                 onClick={() =>
        //                     this.props.redirectToPage("SingleProductDetail", listPreOrder[i].id)
        //                 }
        //             >
        //                 <TextStyle variation="strong">{listPreOrder[i].name}</TextStyle>
        //             </h3>
        //         </div>,
        //     )
        //     array.push(
        //         <div className={listPreOrder[i].status ? "status-enable" : ""}>
        //             <Badge progress="complete" className="Badge-enbale">
        //                 {listPreOrder[i].status ? "Enable" : "Disabled"}
        //             </Badge>
        //         </div>,
        //     )
        //     array.push(
        //         <ButtonGroup segmented>
        //             <Button
        //                 icon={<Icon source={EditMinor} />}
        //                 onClick={() =>
        //                     this.props.redirectToPage("SingleProductDetail", listPreOrder[i].id)
        //                 }
        //                 size="slim"
        //             ></Button>
        //             <Button
        //                 destructive
        //                 icon={<Icon source={DeleteMinor} />}
        //                 size="slim"
        //                 onClick={() => this.handleDeletePreOrder(i)}
        //             ></Button>
        //         </ButtonGroup>,
        //     )
        //     rows.push(array)
        // }

        // if (listCheckbox.length) {
        //     heading = []
        //     heading.push(
        //         <ButtonGroup segmented>
        //             <Button onClick={() => this.handleCheckAll()}>
        //                 <Checkbox
        //                     onChange={() => this.handleCheckAll()}
        //                     checked={checkAll}
        //                     label={`${listCheckbox.length} selected`}
        //                 />
        //             </Button>
        //             <Button
        //                 destructive
        //                 icon={<Icon source={DeleteMinor} />}
        //                 onClick={() => this.handleDeleteList()}
        //             >
        //                 Delete
        //             </Button>
        //         </ButtonGroup>,
        //     )

        //     if (document.getElementsByTagName("th")[0]) {
        //         let th = document.getElementsByTagName("th")[0]
        //         th.setAttribute("colspan", 4)
        //     }
        // } else {
        //     if (document.getElementsByTagName("th")[0]) {
        //         let th = document.getElementsByTagName("th")[0]
        //         th.removeAttribute("colspan")
        //     }
        // }

        return (
            <>
                <Page
                    title="Multiple Products"
                    primaryAction={{
                        content: "Create Profile",
                        onAction: () => this.handleCreateProfile(),
                    }}
                >
                    <Banner status="info" onDismiss={() => {}}>
                        <p>
                            Configure pre-order a group of products in this page. If you want to
                            configure for separate product or variant, go to Single Product
                        </p>
                    </Banner>

                    {loaded ? (
                        <div style={{ marginTop: "2rem" }}>
                            <Card>
                                <Card.Section>
                                    <TextField
                                        value={searchSingleProduct}
                                        // onChange={(val) => this.handleSearchSingleProduct(val)}
                                        placeholder="Search products"
                                        type="search"
                                        prefix={<Icon source={SearchMinor} />}
                                    ></TextField>
                                </Card.Section>
                                <Card.Section>
                                    <DataTable
                                        columnContentTypes={["text", "text", "text", "text"]}
                                        headings={heading}
                                        rows={rows}
                                    ></DataTable>
                                </Card.Section>
                            </Card>
                        </div>
                    ) : (
                        <Stack distribution="center">
                            <div style={{ marginTop: "20px", display: "flex" }}>
                                <Spinner
                                    accessibilityLabel="Loading more customers"
                                    size="large"
                                    color="teal"
                                />
                            </div>
                        </Stack>
                    )}

                </Page>
            </>
        )
    }
}
